"use client";

import type { Session } from "next-auth";
import { SessionProvider as NextAuthSessionProvider } from "next-auth/react";

interface SessionProviderProps {
  children: React.ReactNode;
  /**
   * Server-seitig aufgelöste Session (aus `auth()` im Layout). Wird als
   * Initialwert an NextAuth übergeben, damit `useSession()` schon beim ersten
   * Render die korrekten Nutzerdaten hat — kein „Benutzer"-Flash und vor allem
   * kein hängenbleibender Fallback nach dem Microsoft-SSO-Login (Feedback #9
   * 2026-06-14: Name/Rolle erschienen erst nach manuellem Reload).
   */
  session?: Session | null;
}

export function SessionProvider({ children, session }: SessionProviderProps) {
  return (
    <NextAuthSessionProvider
      session={session}
      refetchInterval={5 * 60}
      // Beim Zurückkehren in den Tab erneut laden — Sicherheitsnetz, falls der
      // erste Session-Fetch direkt nach dem SSO-Redirect ins Leere lief
      // (Feedback #9).
      refetchOnWindowFocus={true}
    >
      {children}
    </NextAuthSessionProvider>
  );
}
